import { FC, useContext } from "react";

import { CardContext } from "../../../../context";
import { CardType } from "../../../../util/enums";
import { CardSlot } from "../../../atoms";
import { useCard } from "../../../../hooks";

interface IRenderEmotionalCardType {
    isForceHoverOn?: boolean
}

const RenderEmotionalCardType: FC<IRenderEmotionalCardType> = ({isForceHoverOn}) => {
const { solutionCardThatNeedsToFlip } = useContext(CardContext);
const [card] = useCard();

    return (
        <div className="solution_cards_in_hand">
            {solutionCardThatNeedsToFlip.emotional ?
                <div></div>
                :
                <div className="solution_cards_in_hand__content">
                    <CardSlot card={card(CardType.EMOTIONAL_SOLUTION)} isForceHoverOn={isForceHoverOn} solutionCardsInHands={true} />
                </div>
            }
        </div>
    );
}

export default RenderEmotionalCardType;